import { render, staticRenderFns } from "./TheMyOrdersTableProductCustomization.vue?vue&type=template&id=8f1db708&scoped=true"
import script from "./TheMyOrdersTableProductCustomization.vue?vue&type=script&lang=js"
export * from "./TheMyOrdersTableProductCustomization.vue?vue&type=script&lang=js"
import style0 from "./TheMyOrdersTableProductCustomization.vue?vue&type=style&index=0&id=8f1db708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1db708",
  null
  
)

export default component.exports